import _ from 'lodash'

const STATE_DESCRIPTIONS = {
  0: 'Запрос на поиск создан', // Создан
  1: 'Запрос отправлен, ожидаем ответа', // Ожидание ответа
  2: 'При выполнении запроса произошла ошибка', // Ошибка
  3: 'Ответ с данными получен и доступен для просмотра', // Ответ получен
}

export function calcLastWebSearchItem(web_search_items) {
  return web_search_items && web_search_items.length > 0 && _.maxBy(web_search_items, (item) => item.id)
}

export function searchInfoText(webSearchItem, estimate) {
  if (webSearchItem && estimate) {
    const state = webSearchItem.current_state

    switch (state) {
      case 0:
      case 1:
      case 2:
        return {
          state: 'secondary',
          text: STATE_DESCRIPTIONS[state],
        }
      case 3:
        const lowCostItemExists = webSearchItem?.payload_response?.results?.some((item) => item.price < estimate.price)
        return lowCostItemExists
          ? {
              state: 'warning',
              text: 'Найдены более дешёвые позиции',
            }
          : {
              state: 'success',
              text: 'Позиции по рыночным ценам',
            }
      default:
        return {
          state: 'secondary',
          text: 'Неизвестное состояние для поиска',
        }
    }
  } else {
    return {
      state: 'secondary',
      text: 'Поиск не назначен',
    }
  }
}

export function getCellOverStyle(over) {
  switch (over) {
    case 1:
      return {
        backgroundColor: '#efebcb',
      }
    case 2:
      return {
        backgroundColor: '#eca8b2',
      }
    default:
      return {
        backgroundColor: 'white',
      }
  }
}

export function comparePrice(estimatePrice, foundPrice) {
  // Проверяем, что входные данные корректны
  if (typeof estimatePrice !== 'number' || typeof foundPrice !== 'number') {
    return 0
  }

  // Вычисляем процентное отклонение foundPrice от estimatePrice
  const priceDifferencePercentage = ((estimatePrice - foundPrice) / estimatePrice) * 100

  // Возвращаем результат в зависимости от процента
  if (priceDifferencePercentage > 5 && priceDifferencePercentage <= 30) {
    return 1
  } else if (priceDifferencePercentage > 30) {
    return 2
  } else {
    return 0
  }
}
